import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90b5515e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Logout")
const _hoisted_2 = ["src"]

import {
  IonApp,
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonRouterOutlet,
  IonToolbar,
  IonHeader,
  menuController,
  IonButtons,
  IonButton,
  IonSplitPane,
  useBackButton,
  useIonRouter,
  getPlatforms,
} from '@ionic/vue';
import {computed, onBeforeUnmount, ref, watch, watchEffect} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {
  closeOutline,
  newspaperOutline,
  settingsOutline,
  barbellOutline,
  bookOutline,
  libraryOutline,
  podiumOutline,
  gameControllerOutline,
  schoolOutline,
  exitOutline,
  homeOutline,
} from 'ionicons/icons';
import {App, AppState} from '@capacitor/app'
import axios from "axios";
import {ScreenOrientation} from "@awesome-cordova-plugins/screen-orientation";
import userService from "@/api/users/UserService";
import FileService from "@/api/file/FileService";
// import router from "@/router";
// import '@/app/app.scss'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()

// Token refresh mechanism - refresh every 5 minutes and on every page load
const TOKEN_REFRESH_INTERVAL = 300000 // 5 minutes in ms
const tokenRefreshInterval = ref<ReturnType<typeof setInterval> | null>(null)

const refreshAuthToken = () => {
  const accessToken = localStorage.getItem('accessToken')
  if (!accessToken) {
    return
  }

  axios.post(`${process.env.VUE_APP_APIURL}user-refresh`, {}, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
      .then(response => {
        const newToken = response.data.data.token
        localStorage.setItem('accessToken', newToken)
        localStorage.setItem('lastTokenRefresh', String(Date.now()))
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + newToken
      })
      .catch(() => {
        // Do nothing - the existing interceptor will handle 401/403
      })
}

// Refresh token immediately on every app load / page reload
if (localStorage.getItem('accessToken')) {
  refreshAuthToken()
}

// Start periodic token refresh every 5 minutes
tokenRefreshInterval.value = setInterval(() => {
  refreshAuthToken()
}, TOKEN_REFRESH_INTERVAL)

const isDesktop = computed(() => getPlatforms().includes('desktop'))

const router = useRouter();

App.addListener('backButton', () => {
  if (!getPlatforms().includes('desktop') && !getPlatforms().includes('mobileweb')) {
    ScreenOrientation.unlock()
    // ScreenOrientation.lock(ScreenOrientation.ORIENTATIONS.PORTRAIT_PRIMARY)
  }
})

if (!getPlatforms().includes('desktop') && !getPlatforms().includes('mobileweb')) {
  ScreenOrientation.lock(ScreenOrientation.ORIENTATIONS.PORTRAIT_PRIMARY)
}

const menuDisabled = () => {
  // setInterval(() => {}, 100)
  return route.fullPath != '/login' && route.fullPath != '/selectclass' && route.name != 'quiz' && route.name != 'newapp' && route.name != 'downloadapp' && route.name != 'logout' && route.name != 'autologin'
  // return this.$route.fullPath == '/login' || this.$route.fullPath == '/selectclass' || this.$route.name == 'quiz'
}

watchEffect(() => {
  console.log(getPlatforms())
  console.log(process.env.VUE_APP_MODE)
  console.log(process.env.VUE_APP_VERSION)
  if (process.env.VUE_APP_MODE === 'desktop' && (getPlatforms().includes('android') || getPlatforms().includes('ios')) && (getPlatforms().includes('iphone') || getPlatforms().includes('mobile')) && !getPlatforms().includes('tablet')) {
    router.replace('/downloadapp')
  }
})

const ionRouter = useIonRouter()

useBackButton(-1, () => {
  if (!ionRouter.canGoBack()) {
    // App.exitApp();
    router.replace('/home')
  }
});

const selectedIndex = ref(0);
const appPages = [
  {
    title: 'Home',
    url: '/home',
    iosIcon: homeOutline,
    mdIcon: homeOutline
  },
  {
    title: 'Play',
    url: '/play',
    iosIcon: gameControllerOutline,
    mdIcon: gameControllerOutline
  },
  {
    title: 'Meetings',
    url: '/lessons',
    iosIcon: libraryOutline,
    mdIcon: libraryOutline
  },
  {
    title: 'Training',
    url: '/training',
    iosIcon: barbellOutline,
    mdIcon: barbellOutline
  },
  {
    title: 'Pressroom',
    url: '/pressroom',
    iosIcon: newspaperOutline,
    mdIcon: newspaperOutline,
  },
  {
    title: 'Ranking',
    url: '/ranking',
    iosIcon: podiumOutline,
    mdIcon: podiumOutline
  },
  {
    title: 'Rules',
    url: '/rules',
    iosIcon: bookOutline,
    mdIcon: bookOutline
  },
  {
    title: 'Classes',
    url: '/selectclass',
    iosIcon: schoolOutline,
    mdIcon: schoolOutline
  },
  {
    title: 'Options',
    url: '/options',
    iosIcon: settingsOutline,
    mdIcon: settingsOutline
  },
  // {
  //     title: 'Logout',
  //     url: '/logout',
  //     iosIcon: exitOutline,
  //     mdIcon: exitOutline
  // }
];

const path = window.location.pathname.split('folder/')[1];
if (path !== undefined) {
  selectedIndex.value = appPages.findIndex(page => page.title.toLowerCase() === path.toLowerCase());
}

const closeMenu = () => {
  menuController.close()
}

const findAppVersion = () => {
  axios.post(`${process.env.VUE_APP_APIURL}auth/check_app_version`, {
    appVersion: process.env.VUE_APP_VERSION,
  })
      .then(response => {
        localStorage.setItem('appVersionCheckTime', JSON.stringify({
          result: response.data.data.can_open_app,
          time: new Date()
        }))
        if (!response.data.data.can_open_app) {
          router.replace({path: '/newapp'})
        }
      })
      .catch(error => {
        console.log(error.response)
        // router.replace({path: '/newapp'})
      })
}

//controllo ogni 5 minuti la versione dell'app per verificare che sia ancora conforme con eventuali aggiornamenti API
findAppVersion()
setInterval(() => {
  findAppVersion()
}, 300000)

const {
  updateUserUsageTimestamp
} = userService()

const {
  updateFileUsageTimeStamp,
} = FileService()

const appStartTime = ref(Date.now())
const getAuthUser = computed(() => localStorage.getItem('accessToken'))
const getCurrentClass = computed(() => JSON.parse(localStorage.getItem('currentClass') || '{}'))

const sendUserUsageTimestamp = () => {
  updateUserUsageTimestamp({
    'class_id': getCurrentClass.value.id,
    'start_time': (appStartTime.value / 1000).toFixed(0),
    'end_time': (Date.now() / 1000).toFixed(0)
  })
}

watch(() => route.fullPath, () => {
  if (route.fullPath === '/logout') {
    updateFileUsageTimeStamp() //Teoricamente inutile non è possibile fare il logout senza chiudere il file
    sendUserUsageTimestamp()
  }
})

App.addListener('appStateChange', (state: AppState) => {
  if (state.isActive) {
    appStartTime.value = Date.now()

    if ((route.fullPath === '/training' || route.fullPath === '/pressroom') && localStorage.getItem('currentFile')) {
      //salvo il fileOpenedAt solo se è aperto
      // per gestire il caso un cui l'utente passa da una tab all'altra,
      // cosi possiamo sapere il momento in cui è tornato sulla scheda
      localStorage.setItem('fileOpenedAt', String((Date.now() / 1000).toFixed(0)))
    }

  } else if (getAuthUser.value || getCurrentClass.value) {
    updateFileUsageTimeStamp()
    sendUserUsageTimestamp()
  }
});

window.addEventListener('beforeunload', (event) => {
  if (getPlatforms().includes('desktop') || getPlatforms().includes('mobileweb')) {
    updateFileUsageTimeStamp()
    //in caso di chiusura o ricaricamento pagine svuoto currentFile e fileOpenedAt
    // perché non verranno riaperti in automatico
    localStorage.removeItem('currentFile')
    localStorage.removeItem('fileOpenedAt')
    sendUserUsageTimestamp()
    appStartTime.value = Date.now()
    event.preventDefault()
    event.returnValue = ''
  }
})

const {
  fetchUser,
  getUser
} = userService()
const currentUser = computed(() => getUser())

if (!currentUser.value.company) {
  fetchUser()
}

const logo = computed(() => {
  if (currentUser.value && currentUser.value.company) {
    if (currentUser.value.company.urls && currentUser.value.company.urls.logo) {
      return currentUser.value.company.urls.logo
    }
    return require('@/assets/logo/switaly_entertraining_logo.png')
  }
  return null
})

const inactivityTimer = ref()
const userInactive = ref(false)

const resetTimer = () => {
  clearTimeout(inactivityTimer.value);
  inactivityTimer.value = setTimeout(() => {
    // Make API call here
    console.log("sessione inattiva")
    userInactive.value = true
    if (getAuthUser.value || getCurrentClass.value) {
      sendUserUsageTimestamp()
    }
  }, 300000) // 5 minutes in milliseconds
}

// Add event listener for mouse movement
window.addEventListener("mousemove", () => {
  resetTimer();
  console.log('sessione riattivata')
  if (userInactive.value) {
    appStartTime.value = Date.now()
  }
})

onBeforeUnmount(() => {
  // Cleanup: Remove event listener
  window.removeEventListener("mousemove", () => {
    sendUserUsageTimestamp()
  })
  // Cleanup: Clear token refresh interval
  if (tokenRefreshInterval.value) {
    clearInterval(tokenRefreshInterval.value)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonSplitPane), {
        disabled: !_unref(isDesktop),
        "content-id": "main-content"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_unref(IonMenu), {
            "content-id": "main-content",
            type: "overlay",
            id: "Menu"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonHeader), { class: "header" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonToolbar), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButtons), { slot: "primary" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace({path: '/logout'})))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                slot: "start",
                                ios: _unref(exitOutline),
                                md: _unref(exitOutline)
                              }, null, 8, ["ios", "md"]),
                              _createVNode(_unref(IonLabel), { class: "label" }, {
                                default: _withCtx(() => [
                                  _hoisted_1
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (!_unref(isDesktop))
                        ? (_openBlock(), _createBlock(_unref(IonMenuToggle), {
                            key: 0,
                            "auto-hide": "false",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (closeMenu())),
                            id: "togglemenu"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                ios: _unref(closeOutline),
                                md: _unref(closeOutline),
                                "auto-hide": "false",
                                size: "large"
                              }, null, 8, ["ios", "md"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonList), {
                    "no-lines": "",
                    lines: "none"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonItem), { class: "item" }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _unref(logo),
                            class: "logo"
                          }, null, 8, _hoisted_2)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonContent), { class: "menu-item ion-padding" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonList), {
                    id: "inbox-list",
                    lines: "none"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(appPages, (p, i) => {
                        return _createVNode(_unref(IonMenuToggle), {
                          "auto-hide": "false",
                          key: i
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonItem), {
                              onClick: ($event: any) => (selectedIndex.value = i),
                              "router-direction": "root",
                              "router-link": p.url,
                              lines: "none",
                              detail: "false",
                              class: _normalizeClass(["hydrated item", { selected: selectedIndex.value === i }])
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonIcon), {
                                  slot: "start",
                                  ios: p.iosIcon,
                                  md: p.mdIcon
                                }, null, 8, ["ios", "md"]),
                                _createVNode(_unref(IonLabel), { class: "label" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(p.title), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick", "router-link", "class"])
                          ]),
                          _: 2
                        }, 1024)
                      }), 64))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512), [
            [_vShow, menuDisabled()]
          ]),
          _createVNode(_unref(IonRouterOutlet), { id: "main-content" })
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _: 1
  }))
}
}

})